import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Loader2, Mail } from "lucide-react";
import RecruitGlanceLogo from "../components/RecruitGlanceLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.detail || "Error sending reset email.");
      }

      setSent(true);
      toast.success(data.message);
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Error sending reset email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#03140f] px-4 py-10">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md rounded-lg border border-white/10 bg-white p-6 text-slate-950 shadow-2xl shadow-black/30 sm:p-8"
      >
        <div className="mb-7 text-center">
          <div className="mb-6 flex justify-center">
            <RecruitGlanceLogo />
          </div>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700">
            <Mail size={22} />
          </div>
          <h2 className="text-2xl font-semibold tracking-tight text-slate-950">Reset your password</h2>
          <p className="mt-2 text-sm leading-6 text-slate-500">
            Enter your account email and we will send a secure password reset link.
          </p>
        </div>

        {sent && (
          <div className="mb-4 flex gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-sm leading-6 text-emerald-800">
            <CheckCircle2 size={18} className="mt-0.5 shrink-0 text-emerald-700" />
            <span>
              If this email exists, a reset link has been sent. Check your inbox and spam folder.
            </span>
          </div>
        )}

        <input
          type="email"
          placeholder="Enter your email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-4 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-emerald-600 focus:ring-2 focus:ring-emerald-100"
        />
        <button
          type="submit"
          disabled={loading}
          className="inline-flex min-h-[42px] w-full items-center justify-center gap-2 rounded-lg bg-emerald-900 px-4 text-sm font-semibold text-white transition hover:bg-emerald-800 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading && <Loader2 size={16} className="animate-spin" />}
          {loading ? "Sending..." : "Send reset link"}
        </button>

        <Link
          to="/login"
          className="mt-5 flex items-center justify-center gap-2 text-sm font-semibold text-slate-600 transition hover:text-slate-950"
        >
          <ArrowLeft size={15} />
          Back to login
        </Link>
      </form>
    </div>
  );
}
